import React from 'react';
import { Box, Typography } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { activeTotal } from '../../utils/memberStatus';
import { COLORS, STATES, pct, fmt } from './signupReportUtils';

const SignupFunnelChart = ({ totals }) => {
  const signed = totals.signed || 0;

  // Active (= Approved + Hidden) is a derived total bar; the seven statuses after
  // it are disjoint and sum to Signed Up.
  const stages = [
    ['Signed Up', signed, COLORS.signed],
    ['Active (Approved + Hidden)', activeTotal(totals), COLORS.active],
    ...STATES.map(([key, name, col]) => [name, totals[key], col]),
  ];

  const options = {
    chart: { type: 'bar', height: 420, backgroundColor: 'transparent' },
    title: { text: null },
    credits: { enabled: false },
    legend: { enabled: false },
    xAxis: {
      categories: stages.map((s) => s[0]),
      lineColor: '#EAEAEA',
      labels: { style: { fontSize: '12px', fontWeight: '600', color: '#404040' } },
    },
    yAxis: {
      min: 0,
      title: { text: null },
      gridLineColor: '#F0F0F0',
      labels: { style: { fontSize: '10px', color: '#737373' } },
    },
    tooltip: {
      formatter() {
        return `<b>${this.x}</b>: ${fmt(this.y)} (${pct(this.y, signed)}%)`;
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        colorByPoint: true,
        colors: stages.map((s) => s[2]),
        dataLabels: {
          enabled: true,
          formatter() {
            return `${fmt(this.y)}  ·  ${pct(this.y, signed)}%`;
          },
          style: { fontSize: '12px', fontWeight: '700', color: '#404040', textOutline: 'none' },
        },
      },
    },
    series: [{ name: 'Signups', data: stages.map((s) => s[1] || 0) }],
  };

  return (
    <Box sx={{ bgcolor: '#fff', border: '1px solid #EAEAEA', borderRadius: '14px', p: 2.2, mb: 2 }}>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#171717' }}>
        Signed Up → Active, with every status
      </Typography>
      <Typography sx={{ fontSize: 11.5, color: '#737373', mb: 2 }}>
        Count and % of signups for every stage · grouped by signup day, shown in each user&apos;s current state
      </Typography>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};

export default SignupFunnelChart;
